import { render, staticRenderFns } from "./UploadDocumentClient.vue?vue&type=template&id=2d484164&scoped=true"
import script from "./UploadDocumentClient.vue?vue&type=script&lang=ts"
export * from "./UploadDocumentClient.vue?vue&type=script&lang=ts"
import style0 from "./UploadDocumentClient.vue?vue&type=style&index=0&id=2d484164&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d484164",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d484164')) {
      api.createRecord('2d484164', component.options)
    } else {
      api.reload('2d484164', component.options)
    }
    module.hot.accept("./UploadDocumentClient.vue?vue&type=template&id=2d484164&scoped=true", function () {
      api.rerender('2d484164', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/UploadDocumentClient.vue"
export default component.exports